import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const SareeCareGuide = () => {
    const { translateSync } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Saree Care Guide | How to Care for Silk Sarees</title>
                <meta name="description" content="Learn how to care for silk sarees, pattu sarees, and zari border sarees with storage, folding, and washing tips." />
                <link rel="canonical" href="https://coloursboutique.com/saree-care-guide" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Saree Care Guide')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Saree Care Guide')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('Storage and Folding')}</h3>
                                            <p className="mb-2">
                                                {translateSync('Always wrap your expensive pure silk Kanjeevarams or Uppada sarees in clean muslin or soft cotton cloth bags. Never store them in plastic bags, as silk needs to breathe.')}
                                            </p>
                                            <p className="mb-0">
                                                {translateSync('Refold your silk sarees every 2-3 months to prevent the zari and fold lines from cracking. Avoid hanging silk sarees on metal hangers as they can leave marks.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('Dry Cleaning')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We strongly recommend professional dry cleaning for all our pure silk, pattu, and zari border sarees, particularly for the first few washes. Avoid machine washing handloom sarees.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Ironing Tips')}</h3>
                                            <p className="mb-0">
                                                {translateSync('When ironing a silk saree at home, use low to medium heat settings. Always place a cotton cloth over the saree while ironing and iron on the reverse side to protect the delicate silk threads and gold zari.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('Stain Removal')}</h3>
                                            <p className="mb-0">
                                                {translateSync('In case of accidental spills, blot the area immediately with clean tissue or soft dry cloth. Do not rub the stain, as this can damage the weave. Take the saree to a dry cleaner as soon as possible.')}
                                            </p>
                                        </div>

                                        <div className="contact-info p-4 rounded-3" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Saree Support')}</h3>
                                            <p className="mb-2">{translateSync('Have a specific query regarding the care of a saree purchased from us?')}</p>
                                            <ul className="list-unstyled mb-0">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone / WhatsApp')}: +91 80562 62626</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default SareeCareGuide;
